// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-info-block{display:flex;align-items:center;background:#f5f5f5;border-radius:0.25rem;padding:12px}.czt-info-block__icon{margin-right:12px}", ""]);
// Exports
module.exports = exports;
